import { defineComponent as i, createElementBlock as t, openBlock as o, mergeProps as u, unref as e, renderSlot as g, createCommentVNode as m, createElementVNode as n } from "vue";
import { useScalarIcon as f } from "../hooks/useScalarIcon.js";
const k = { key: 0 }, w = { key: 1 }, M = { key: 2 }, Z = { key: 3 }, h = { key: 4 }, y = { key: 5 }, _ = {
  name: "ScalarIconCaretDown"
}, C = /* @__PURE__ */ i({
  ..._,
  props: {
    label: {},
    weight: {}
  },
  setup(a) {
    const s = a, { bind: d, weight: r } = f(s);
    return (p, l) => (o(), t("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(r) === "bold" ? (o(), t("g", k, l[0] || (l[0] = [
        n("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }, null, -1)
      ]))) : e(r) === "duotone" ? (o(), t("g", w, l[1] || (l[1] = [
        n("path", {
          d: "M208,96l-80,80L48,96Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }, null, -1)
      ]))) : e(r) === "fill" ? (o(), t("g", M, l[2] || (l[2] = [
        n("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }, null, -1)
      ]))) : e(r) === "light" ? (o(), t("g", Z, l[3] || (l[3] = [
        n("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }, null, -1)
      ]))) : e(r) === "regular" ? (o(), t("g", h, l[4] || (l[4] = [
        n("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
      ]))) : e(r) === "thin" ? (o(), t("g", y, l[5] || (l[5] = [
        n("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  C as default
};
